import { render, staticRenderFns } from "./Mural.vue?vue&type=template&id=68be0b46"
import script from "./Mural.vue?vue&type=script&lang=js"
export * from "./Mural.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports